import React from 'react'
import { Box } from 'rebass/styled-components'

import Layout from '../components/Layout'
import Section from '@components/Section'

const Imprint = props => {
  return (
    <Layout>
      <Box mt={[20]}>
        <Section title="Imprint">
          <Box pb={[128]} width={[1, 1, 1, 6 / 12]}>
            <small>
              Angaben gemäß § 5 TMG <br /> <br />
              Studio Mark Randel <br />
              Tucholskystraße 47 <br />
              10117 Berlin, Deutschland <br /> <br />
              Vertreten durch den Geschäftsführer: Mark Randel <br />
              Berufsbezeichnung: Architekt <br />
              Architektenkammer: Architektenkammer Berlin, Deutschland <br />
              <br />
              Umsatzsteuer-ID: DE292702049 <br />
              <br />
              Kontakt <br />
              <br />
              Telefon: +49 30 288 840 77 <br />
              E-Mail: mail@studiomarkrandel.com
              <br />
            </small>
          </Box>
        </Section>

        <Section pt={[20]} title="Privacy Policy">
          <Box pb={[128]} width={[1, 1, 1, 6 / 12]}>
            <small>
              Bei der Nutzung unserer Internetseite speichern wir keine
              personenbezogenen Daten.
              <br />
              <br />
              Verantwortlicher im Sinne der Datenschutz-Grundverordnung,
              sonstiger in den Mitgliedstaaten der Europ&auml;ischen Union
              geltenden Datenschutzgesetze und anderer Bestimmungen mit
              datenschutzrechtlichem Charakter ist:
              <br />
              <br />
              Studio Mark Randel
              <br />
              Tucholskystra&szlig;e 47
              <br />
              10117 Berlin, Deutschland
              <br />
              <br />
              Vertreten durch: Dipl.-Ing. Mark Randel
              <br />
              Berufsbezeichnung: Architekt
              <br />
              Architektenkammer: Architektenkammer Berlin, Deutschland
              <br />
              <br />
              Kontakt:
              <br />
              E-Mail: mail@studiomarkrandel.com
              <br />
              <br />
              Cookies
              <br />
              <br />
              Unsere Website verwendet Cookies. Das sind kleine Textdateien, die
              Ihr Webbrowser auf Ihrem Endger&auml;t speichert. Cookies helfen
              uns dabei, unser Angebot nutzerfreundlicher, effektiver und
              sicherer zu machen.
              <br />
              <br />
              Die verwendeten Cookies enthalten keine personenbezogenen Daten,
              sondern dienen nur zur Speicherung der Benutzereinstellung
              hinsichtlich der Sprache der Webseite.
              <br />
              <br />
              Content-Delivery-Network von Netlify
              <br />
              <br />
              Wir setzen ein so genanntes &quot;Content Delivery Network&quot;
              (CDN), angeboten von Netlify, Inc., ein.
              <br />
              <br />
              Ein CDN ist ein Dienst, mit dessen Hilfe Inhalte unseres
              Onlineangebotes, insbesondere gro&szlig;e Mediendateien, wie
              Grafiken oder Skripte mit Hilfe regional verteilter und &uuml;ber
              das Internet verbundener Server, schneller ausgeliefert werden.
              Die Verarbeitung der Daten der Nutzer erfolgt alleine zu den
              vorgenannten Zwecken und der Aufrechterhaltung der Sicherheit und
              Funktionsf&auml;higkeit des CDN.
              <br />
              <br />
              Die Nutzung erfolgt auf Grundlage unserer berechtigten Interessen,
              d.h. Interesse an einer sicheren und effizienten Bereitstellung,
              Analyse sowie Optimierung unseres Onlineangebotes gem. Art. 6 Abs.
              1 lit. f. DSGVO.
              <br />
              <br />
              Weitere Informationen erhalten Sie in der
              Datenschutzerkl&auml;rung von Netlify:
              https://www.netlify.com/gdpr/.
            </small>
          </Box>
        </Section>
      </Box>
    </Layout>
  )
}

export default Imprint
